import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { QuickBuild } from 'src/app/people/quick-build.service';
import { JobFunctions, JobLevels } from 'src/app/shared/dw-column';
import {
  PrevNextFlowComparisonConfig,
  HeadcountComparisonConfig,
  TenureCurrentBreakdownConfig,
  JobStartsAndEndsConfig,
  PrevNextFlowConfig,
  DemographicsConfig,
  DemographicsCurrentConfig,
  LocationMapConfig,
  TopValuesComparisonConfig,
  JobsMovesComparisonConfig,
  HistoricalTenureComparisonConfig,
  TenureCohortComparisonConfig,
} from 'src/app/shared/report-visualizations/interfaces/report-config.interfaces';
import { RoleDefinition } from 'src/app/core/services/role-definitions.service';

// Chart configurations by chart ID
interface ChartConfigurations {
  'talent-flow'?: PrevNextFlowConfig;
  'job-starts-and-ends'?: JobStartsAndEndsConfig;
  'demographics-over-time'?: DemographicsConfig;
  'current-demographics'?: DemographicsCurrentConfig;
  'location-map'?: LocationMapConfig;
  'tenure-current-breakdown'?: TenureCurrentBreakdownConfig;
  'headcount-comparison'?: HeadcountComparisonConfig;
  'top-values-comparison'?: TopValuesComparisonConfig;
  'job-moves-comparison'?: JobsMovesComparisonConfig;
  'historical-tenure-comparison'?: HistoricalTenureComparisonConfig;
  'talent-flow-comparison'?: PrevNextFlowComparisonConfig;
  'tenure-cohort-comparison'?: TenureCohortComparisonConfig;
}

@Component({
  selector: 'app-insights-dashboard',
  templateUrl: './insights-dashboard.component.html',
  styleUrls: ['./insights-dashboard.component.scss'],
  standalone: false,
})
export class InsightsDashboardComponent implements OnChanges {
  @Input() quickBuild: QuickBuild | null = null;
  @Input() companyBattleQBs: QuickBuild[] = [];
  @Input() benchmarkCompanyQBs: QuickBuild[] = [];
  @Input() dateRangeStrings: [string, string] = ['', ''];
  @Input() mode: 'company' | 'battle' | 'benchmark' = 'company';
  @Input() chartConfigs: ChartConfigurations = {};
  @Input() reportTarget: string = 'moneyball';
  @Input() selectedJobFunctions: JobFunctions[] = [];
  @Input() selectedJobLevels: JobLevels[] = [];
  @Input() selectedRole: RoleDefinition | null = null;

  @Output() chartConfigChange = new EventEmitter<{ chartId: string; config: any }>();

  ngOnChanges(changes: SimpleChanges): void {
    // Handle any change detection logic if needed
  }

  onChartConfigChange(chartId: string, config: any) {
    this.chartConfigChange.emit({ chartId, config });
  }
}
